import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Image from "../../elements/image";
import { getOverallSettingsClasses } from "../../utils/siteUtils";

import "./style.scss";

const ImageContainer = ({ image }) => (
  <div className="image-banner-container">
    <div className="image-banner-wrapper">
      <Image {...image.value} />
    </div>
  </div>
);

const ImageBanner = props => {
  const { backgroundColor, image, link } = props.fields;
  const params = props.params;
  const imageBannerClasses = classNames("image-banner", getOverallSettingsClasses(props.fields));
  const url = link && link.value && link.value.href;
  const linkType = link && link.value && link.value.linktype;
  if (linkType === "internal") {
    return (
      <Link
        to={url}
        className={imageBannerClasses}
        pagetype={params?.pageType}
        style={{
          background: backgroundColor?.fields && backgroundColor.fields.phrase.value
        }}
      >
        <ImageContainer image={image} />
      </Link>
    );
  } else if (linkType === "external") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={imageBannerClasses}
        pagetype={params?.pageType}
        style={{
          background: backgroundColor?.fields && backgroundColor.fields.phrase.value
        }}
      >
        <ImageContainer image={image} />
      </a>
    );
  } else {
    return (
      <div
        className={imageBannerClasses}
        pagetype={params?.pageType}
        style={{
          background: backgroundColor?.fields && backgroundColor.fields.phrase.value
        }}
      >
        <ImageContainer image={image} />
      </div>
    );
  }
};

ImageBanner.propTypes = {
  fields: PropTypes.shape({
    backgroundColor: PropTypes.object,
    link: PropTypes.object,
    image: PropTypes.object.isRequired
  })
};

export default ImageBanner;
